<template>
  <b-card v-if="data" no-body class="card-statistics">
    <b-card-header>
      <b-card-title>{{ title || "Statistique" }}</b-card-title>
    </b-card-header>
    <b-card-body class="statistics-body">
      <b-row>
        <b-col
          v-for="item in data"
          :key="item.icon"
          :xl="value[0]"
          :md="value[1]"
          :sm="value[2]"
          :class="item.customClass"
        >
          <b-media no-body>
            <b-media-aside class="mr-2">
              <b-avatar size="48" :variant="item.color">
                <feather-icon size="24" :icon="item.icon" />
              </b-avatar>
            </b-media-aside>
            <b-media-body class="my-auto">
              <h4 class="font-weight-bolder mb-0">
                {{ item.title }}
              </h4>
              <b-card-text class="font-small-3 mb-0">
                {{ item.subtitle }}
              </b-card-text>
            </b-media-body>
          </b-media>
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard,
  BCardHeader,
  BCardTitle,
  BCardText,
  BCardBody,
  BRow,
  BCol,
  BMedia,
  BMediaAside,
  BAvatar,
  BMediaBody,
} from "bootstrap-vue";

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardText,
    BCardBody,
    BMedia,
    BAvatar,
    BMediaAside,
    BMediaBody,
  },
  props: {
    title: {
      type: String,
    },
    data: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      value: [],
    };
  },
  async created() {
    console.log(this._props.data);
    if (this._props.data == 1) {
      this.value = ["12", "12", "12"];
    } else if (this._props.data == 2) {
      this.value = ["6", "6", "6"];
    } else if (this._props.data == 3) {
      this.value = ["4", "4", "6"];
    } else if (this._props.data == 4) {
      this.value = ["3", "3", "6"];
    } 
    else if (this._props.data == 5) {
      this.value = ["2", "2", "6"];
    } 
  },
  methods: {},
};
</script>
